import React from "react";
import { APStatus } from "../../constant/assistanceProgram";
import { WaitList, Close, Open, WaitListOnly } from "./index";
import { programTypeMapper } from "@tailormed/common-client/util/programTypeMapping";

export const ApplicationStatusTag = ({ status, potentialSaving }) => {
  const isFoundationProgram = programTypeMapper.isFoundationProgram(potentialSaving);

  return (
    <>
      {status === APStatus.WAITLIST && <WaitList />}
      {status === APStatus.CLOSED && <Close />}
      {isFoundationProgram && status === APStatus.OPEN && <Open />}
      {status === APStatus.WAITLIST_ONLY && <WaitListOnly />}
    </>
  );
};
